import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () => {
  return 'ai_assistant' + (Math.floor(Math.random() * 90000000) + 10000).toString();
};

const defaultAiAssistantData = () => ({
  task: '',
  context: '',
  imageContext: [],
  outputPlaceholders: [
    {
      desc: '',
      key: keyAuto(),
      type: 'text',
    },
  ],
  gptModel: 'gpt-5-mini',
});

const initData = () => ({
  aiAssistantData: defaultAiAssistantData(),
});

const onLoadData = (rawData) => {
  return JSON.parse(JSON.stringify(rawData));
};

const { getStore, defaultStore } = createComponentStore({
  type: 'ai_assistant',
  endpoint: 'ai-assistant',
  registryKey: 'ai_assistant',
  initData,
  onLoadData,

  extraState: () => ({
    placeholders: [],
    position: null,
    focus: null,
    imageContext: [],
  }),

  extraActions: (set, get) => ({
    setPlaceholders: (placeholders) => {
      set({ placeholders: [...placeholders] });
    },

    setAIOutputPlaceholders: (aiOutPutPlaceholders) => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.aiAssistantData.outputPlaceholders = aiOutPutPlaceholders;
      set({ data });
    },

    setGptModel: (gptModel) => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.aiAssistantData.gptModel = gptModel;
      set({ data });
    },

    setFocus: (index) => {
      set({ placeholders: [], position: index });
    },

    setTask: (task) => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.aiAssistantData.task = task;
      set({ data });
    },

    setContext: (context) => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.aiAssistantData.context = context;
      set({ data });
    },

    clearImageContext: () => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.aiAssistantData.imageContext = [];
      set({ data });
    },

    setImageContext: (imageContext) => {
      const data = JSON.parse(JSON.stringify(get().data));
      if (data.aiAssistantData.imageContext) {
        for (let i = 0; i < data.aiAssistantData.imageContext.length; i++) {
          if (data.aiAssistantData.imageContext[i] === imageContext) {
            return;
          }
        }
        data.aiAssistantData.imageContext.push(imageContext);
      } else {
        data.aiAssistantData.imageContext = [imageContext];
      }
      set({ data });
    },

    deleteChip: (index) => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.aiAssistantData.imageContext.splice(index, 1);
      set({ data });
    },

    // Override getTemplate to include extra fields
    getTemplate: () => {
      const { componentId, name, position, data, type, lastModified, placeholders, imageContext } = get();
      return {
        componentId,
        name,
        position,
        data: JSON.parse(JSON.stringify(data)),
        type,
        lastModified,
        placeholders,
        imageContext,
      };
    },

    // Override setTemplateData to deep-clone
    setTemplateData: (data) => {
      set({ data: JSON.parse(JSON.stringify(data)) });
    },

    // Backward-compatible alias
    setAiAssistantVariables: (component) => {
      get().setComponentData(component);
    },
  }),
});

export function getAIAssistantTemplateStore(componentId) {
  return getStore(componentId);
}

export default defaultStore;
